<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 1346 1346" style="enable-background:new 0 0 1346 1346" xml:space="preserve">
    <path :style="`fill-rule:evenodd;clip-rule:evenodd;fill:${back}`" id="back" transform="rotate(45.001 737.19 607.107)" style="" d="M461.9 230.4h550.5v753.5H461.9z"/>
    <path id="front" :style="`fill-rule:evenodd;clip-rule:evenodd;fill:${front}`" d="M679.6 1024.8 328.2 673.5l509.1-509.1L673 0 0 673l673 673 673-673-157.3-157.3z"/>
    <path id="wedge" :style="`fill-rule:evenodd;clip-rule:evenodd;fill:${front}`" transform="rotate(-45.001 803.941 541.854)" d="M513.2 426.4h581.4v230.9H513.2z"/>
</svg>
</template>

<script>
export default {
    props: ['front', 'back'],
}
</script>